import { ProjectLocationEditor } from "@components/project-location-editor/project-location-editor";
import { WorldMap } from "@components/world-map/world-map";
import { isSdbProjectWithPosition } from "@custom-types/project-type-guards";
import { EditIcon, Skeleton } from "@flat-ui";
import { ProjectMapEmptyPage } from "@pages/project-details/project-overview/project-map/project-map-empty-page";
import { trackOpenProjectLocationEditor } from "@utils/project-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useEffect, useRef, useState } from "react";
/**
 * Component that displays a map with the location of a single project.
 */
export function ProjectMap({
  project,
  shouldShowSkeleton = false,
  isInteractive = true
}) {
  const {
    trackEvent
  } = useTrackEvent();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const entities = isSdbProjectWithPosition(project) ? [project] : [];
  const mapRef = useRef(null);
  const positionRef = useRef(project.position);

  /** Handles opening the dialog */
  function openDialog() {
    trackOpenProjectLocationEditor({
      trackEvent,
      source: "project details page"
    });
    setIsDialogOpen(true);
  }

  /** Handles closing the dialog */
  function closeDialog() {
    setIsDialogOpen(false);
  }
  const buttons = isInteractive ? [{
    icon: <EditIcon sx={{
      width: "19px",
      height: "19px"
    }} />,
    onClick: openDialog,
    tooltip: "Update coordinates"
  }] : [];

  // Listens for updates in the project position and sets the map view to the new position.
  // Early exit if the new position has the same value as the cached/referenced position.
  useEffect(() => {
    if (project.position?.lat === positionRef.current?.lat && project.position?.lng === positionRef.current?.lng) {
      return;
    }
    positionRef.current = project.position;
    if (project.position) {
      mapRef.current?.goTo(project.position);
    }
  }, [project.position]);
  if (shouldShowSkeleton) {
    return <Skeleton variant="rectangular" height="100%" />;
  }
  if (!entities.length) {
    return <ProjectMapEmptyPage project={project} isDialogOpen={isDialogOpen} openDialog={openDialog} closeDialog={closeDialog} isInteractive={isInteractive} />;
  }
  return <>
      <WorldMap mapRef={mapRef} entities={entities} mapContext="project overview" buttons={buttons} />
      {isInteractive && isDialogOpen && <ProjectLocationEditor project={project} onClose={closeDialog} />}
    </>;
}